import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { UserRole } from '@api/models/enums/UserRole';

const exludedRoles: UserRole[] = [
  UserRole.AdminQcs,
  UserRole.ExternalManager,
  UserRole.ExternalWorker,
  UserRole.ExternalOneTime,
  UserRole.RemoteToken,
];

const options = Object.values(UserRole).filter(
  (x) => !exludedRoles.includes(x)
);

interface Props {
  value?: UserRole[];
  onChange: (value?: UserRole) => void;
}

export const GridFilterUserRole: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  if (!value) return null;

  return (
    <GridFilterSelectMultiple
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: UserRole) => option}
      getOptionName={(option: UserRole) => t(`user.role.${option}`)}
    />
  );
};
